import { IChatConfigState } from "../features/chatConfig/chatConfigSlice";

export interface IConfig {
  chatMode: string;
  campaignId: string;
  campaignName: string;
  applicationId: string;
  variantId: string;
  processScriptId: string;
  initialConversation: string;
  chatbotGroup: string;
  botImage: string;
  userImage: string;
  chatBg: string;
  chatStyle: string;
  chatTransferMsg: string;
  noAgentMsg: string;
  isVoiceEnabled: string;
  isTextEnabled: string;
  voiceName: string;
  languageCode: string;
  userResponseTimeout: string;
  userQuestion: string;
}

const convertStateToConfig = (state: IChatConfigState): IConfig | null => {
  if (state.chatConfig) {
    return {
      applicationId: state.chatConfig.config.queue1.applicationId,
      botImage: "",
      campaignId: state.chatConfig.config.campaignId,
      campaignName: state.campaignDetails?.CampaignName || "",
      chatBg: state.chatConfig.config.queue1.chatStyle.chatBGColor,
      chatbotGroup: state.chatConfig.config.queue1.chatbotGroup,
      chatMode: state.chatMode,
      chatStyle: JSON.stringify(state.chatConfig.config.queue1.chatStyle),
      chatTransferMsg: state.chatConfig.config.liveChat.chatTransferMsg,
      initialConversation: state.chatConfig.config.queue1.initialConversation,
      isTextEnabled: `${state.chatConfig.config.queue1.isTextEnabled}`,
      isVoiceEnabled: `${state.chatConfig.config.queue1.isVoiceEnabled}`,
      languageCode: state.chatConfig.config.queue1.languageCode,
      noAgentMsg: state.chatConfig.config.liveChat.noAgentMsg,
      processScriptId: state.chatConfig.config.queue1.processScriptId,
      variantId: state.chatConfig.config.queue1.variantId || state.chatConfig.config.queue1.processScriptId,
      userImage: "",
      userResponseTimeout: JSON.stringify(state.chatConfig.config.userResponseTimeout),
      voiceName: state.chatConfig.config.queue1.voiceName,
      userQuestion: state.userQuestion,
    };
  } else {
    return null;
  }
};

export const generateQueryString = (state: IChatConfigState) => {
  if (state.chatConfig) {
    let result = "";
    Object.entries(convertStateToConfig(state) || {}).forEach(([key, value]) => {
      result += `&${key}=${value}`;
    });
    return result;
  } else {
    return "";
  }
};
